import { render, staticRenderFns } from "./CardText.vue?vue&type=template&id=fb07872a&scoped=true"
import script from "./CardText.vue?vue&type=script&lang=js"
export * from "./CardText.vue?vue&type=script&lang=js"
import style0 from "./CardText.vue?vue&type=style&index=0&id=fb07872a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb07872a",
  null
  
)

export default component.exports